<template>
  <div class="layer2">
    <div class="header-title">
      <img src="../../images/sprite-left.png" alt="">
      <span>{{list.floorName}}</span>
      <img src="../../images/sprite-right.png" alt="">
    </div>
    <div class="goodList">
      <ul class="ul-cls goodList" v-if="list.upModels">
        <li v-for="item in list.upModels[classifyIndex].goodsInfo" :key="item.goodsId">
          <div class="sale" v-if="item.activityType">
            <span>{{item.activityType}}</span>
          </div>
          <!--eslint-disable-next-line-->
          <a :href="`/storeGoodInfo?goodId=${item.goodsId}`"
             target="_blank">
            <div class="goodImg">
              <img :src="`${item.goodsImg}?imageView2/1/w/145/h/145`" alt="" v-if="item.goodsImg" />
              <img src="../../images/goods.jpg" alt="" v-else />
            </div>
            <div class="tagList">
              <!--<span class="tag">农信优选</span>-->
            </div>
            <div class="title">{{item.goodsName}}</div>
            <div v-if="openType && isAllowLogin">
              <div v-if="item.sellFactPrice">
                <span class="newPrice">￥{{item.sellFactPrice}}</span>
                <span class="oldPrice" v-if="item.sellFactPrice !== item.sellPrice">
              ￥{{item.sellPrice}}
            </span>
              </div>
              <span class="newPrice" v-else>点击询价</span>
            </div>
            <span class="newPrice" v-else>点击询价</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Layer1',
  props: {
    type1: Object,
    isOpen: Boolean,
  },
  data() {
    return {
      origin: process.env,
      list: this.type1,
      openType: this.isOpen,
      classifyIndex: 0,
    };
  },
  computed: mapState({
    isAllowLogin: state => state.app.isAllowLogin,
  }),
  watch: {
    type1(newVal) {
      this.list = newVal;
    },
    isOpen(newVal) {
      this.openType = newVal;
    },
  },
};
</script>
